import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { Modal } from "antd";
import React from 'react';

export const windowOpenPopUpFallback = (url, popupModalTitle, popupModalContent, target = '_blank', rel = 'noopener,noreferrer') => {
    const newTab = window.open();
    // console.log('aaa newTab', {newTab, statementWithRemarks});
    if (newTab) {
        newTab.location.href = url;
        newTab.target = target;
        newTab.rel = rel;
    }
    // in ios browsers, pop-ups might be blocked if url is opened without user actions (newTab === null)
    // so we need to show a modal and ask user to click to open in new tab
    else {
        Modal.confirm({
            title: popupModalTitle,
            content: (
                <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                    {popupModalContent}
                </I18nProvider>
            ),
            onOk() {
                window.open(url);
            },
        });
    }
};
